<template>
    <c-dialog ref="dialog" width="600" mode="slide" mask-close @close="dialogFormEditConfirm($refs.form, arguments)">
        <c-form ref="form" vertical unit-width="100%">
            <c-input type="hidden" name="id"></c-input>
            <c-input type="hidden" name="document_number"></c-input>
            <c-input type="hidden" name="reimbursement_type"></c-input>

            <c-field v-if="editState && detailData.document_number" label="单据编号">{{detailData.document_number}}</c-field>

            <c-form-item label="紧急程度" required>
                <c-radio-group name="emergency_level" :options="urgencyLevelDic" :value="1"></c-radio-group>
            </c-form-item>

            <c-form-item label="报销类型" required>
                <c-select v-model="reimbType" name="reimbursement_type" :options="reimbursementTypeDic" @change="onReimbTypeChange"></c-select>
            </c-form-item>

            <c-form-item v-show="reimbType == 1" label="关联工单" required>
                <c-select name="order_id" v-model="order_id" async @search="searchAftersaleOrder" :value-data="orderOptions" :clear="false"></c-select>
                <info-card code="AFTERSALE_ORDER" :id="order_id"></info-card>
            </c-form-item>

            <c-form-item label="所在公司" required>
                <c-select name="company_id" async @search="searchCompany" :value-data="selectedCompany" clearable></c-select>
            </c-form-item>

            <c-form-item v-show="reimbType == 1" label="服务单据" required>
                <c-upload-file v-model="receiptsImageUrl" name="receipts_image_url" type="image,pdf" multiple :limit="6" media></c-upload-file>
            </c-form-item>
            <c-form-item v-show="reimbType == 1" label="拉力报告">
                <c-upload-file v-model="reportImageUrl" name="report_image_url" type="image,pdf" multiple :limit="6" media></c-upload-file>
            </c-form-item>

            <c-form-item label="报销明细" name="item_list" required>
                <div v-for="(item, index) in itemList" :key="index" class="item-card">
                    <c-form unit-width="100%">
                        <c-form-item v-show="reimbType == 1" label="报销类型" required>
                            <c-radio-group v-model="item.item_type">
                                <c-radio value="1">公共费用</c-radio>
                                <c-radio value="2">个人费用</c-radio>
                            </c-radio-group>
                        </c-form-item>
                        <c-form-item label="报销项" required>
                            <c-select v-model="item.item_code" :options="expenseItemCodeDic[item.item_type]" placeholder="选择" @change="onItemCodeChange(item, $event)"></c-select>
                        </c-form-item>
                        <c-form-item label="开始日期" required>
                            <c-datetime v-model="item.start_date" type="date" placeholder="选择"></c-datetime>
                        </c-form-item>
                        <c-form-item label="结束日期" required>
                            <c-datetime v-model="item.end_date" type="date" placeholder="选择" @change="changeDate(item, 'end_date')"></c-datetime>
                        </c-form-item>
                        <c-form-item label="金额" required>
                            <c-input v-model="item.item_amount" type="number" decimal="2" :range="[0, 99999999]" placeholder="0.00" append-text="元" @change="calcTotal"></c-input>
                        </c-form-item>
                        <c-form-item v-if="reimbType == 1" label="报销人" required>
                            <c-select v-model="item.reimburser_user_id" :options="memberList" placeholder="选择"></c-select>
                        </c-form-item>
                        <c-form-item label="费用描述">
                            <c-input v-model="item.expense_detail" placeholder="请输入"></c-input>
                        </c-form-item>
                        <c-form-item label="票据凭证" :required="item.is_required_voucher == 1">
                            <c-upload-file v-model="item.voucher_images" :name="item.is_required_voucher == 1 ? 'voucher_images' : ''" type="image,word,excel,pdf" multiple :limit="9" media></c-upload-file>
                        </c-form-item>
                    </c-form>
                    <div class="flex-end">
                        <c-button type="text" color="red" @click="removeItem(index)">删除</c-button>
                    </div>
                </div>
                <c-button color="main" prepend-icon="tf-add" @click="addItem" size="form" style="width: 100%;">添加报销项</c-button>
            </c-form-item>
            <c-form-item label="合计金额">
                <c-input :value="totalAmount" disabled append-text="元"></c-input>
            </c-form-item>

            <c-form-item label="备注">
                <c-input name="remarks" type="textarea" maxlength="1000" :rows="3" placeholder="可描述一下具体情况"></c-input>
            </c-form-item>

            <c-form-item label="收款账号" required>
                <template #handle>
                    <c-link type="text" @click="manageBankAccount">管理收款账号</c-link>
                </template>
                <c-input type="hidden" name="payee_name"></c-input>
                <c-input type="hidden" name="payee_bank_name"></c-input>
                <c-input type="hidden" name="payee_card_no"></c-input>
                <c-select ref="bankAccountSelect" async @search="searchBankAccount" @change="onBankAccountChange" placeholder="请选择收款账号"></c-select>
                <!-- <c-tips v-if="!payeeCardNo" type="warning">暂无银行卡，请先点击「管理」添加</c-tips> -->
            </c-form-item>
        </c-form>
        <template #button>
            <c-button size="form" v-if="!editState || order_status == -1" @click="submitHandle(-1)">暂存草稿</c-button>
            <c-button size="form" color="main" @click="submitHandle(1)">提交数据</c-button>
        </template>

        <workflow-launch ref="workflowLaunch"></workflow-launch>
        <account-selector ref="accountSelector" @refresh="onAccountRefresh"></account-selector>
    </c-dialog>
</template>

<script>
import {mapState} from "vuex";
import workflowLaunch from "@/components/service/workflow_launch.vue";
import AccountSelector from "@/components/service/account_selector.vue";
export default {
    components: {workflowLaunch, AccountSelector},
    computed: {
        ...mapState(['urgencyLevelDic', 'reimbursementTypeDic']),
        totalAmount() {
            let total = 0;
            this.itemList.forEach(item => {
                const amt = parseFloat(item.item_amount);
                if (!isNaN(amt)) total += amt;
            });
            return total.toFixed(2);
        },
    },
    data() {
        return {
            order_status: -1,
            itemList: [],
            editState: false,
            detailData: {},
            reimbType: '',
            order_id: 0,
            outsourceOrder: false,
            orderOptions: [],
            expenseItemCodeDic: [],
            selectedCompany: [],
            payeeCardNo: '',
            memberList: [],
            receiptsImageUrl: '',
            reportImageUrl: ''
        }
    },
    watch: {
        order_id(val) {
            if (val) {
                // 加载工单成员列表，与移动端一致
                this.request({
                    url: '/after/sale/order/detail',
                    data: {id: val},
                    success: ({detailInfo, memberList}) => {
                        this.memberList = (memberList || []).map(item => ({
                            name: item.user_realname,
                            value: item.user_id
                        }));
                        this.outsourceOrder = detailInfo.outsource_recruit_count > 0;
                    }
                });
            } else {
                this.memberList = [];
            }
        },

        outsourceOrder() {
            this.initExpenseItemCodeDic([1]);
        }
    },

    methods: {
        async open(data) {
            this.$refs.form.clear();
            this.itemList = [];
            this.editState = false;
            this.detailData = {};
            this.reimbType = '';
            this.receiptsImageUrl = '';
            this.reportImageUrl = '';

            if (data) {
                this.request({
                    url: '/expense/reimbursement/detail',
                    data: {id: data.id},
                    success: res => {
                        const detailData = res.detailInfo;
                        this.order_status = detailData.status || -1;
                        this.detailData = detailData;
                        this.reimbType = detailData.reimbursement_type;
                        // 用详情数据回填表单，确保服务单据、拉力报告等字段正确回显
                        this.$refs.form.set(detailData);
                        // 服务单据和拉力报告通过 v-model 回显
                        this.receiptsImageUrl = detailData.receipts_image_url || '';
                        this.reportImageUrl = detailData.report_image_url || '';
                        // 紧急程度从详情数据中获取，确保单选按钮正确选中
                        if (detailData.emergency_level !== undefined && detailData.emergency_level !== null) {
                            this.$refs.form.set({emergency_level: detailData.emergency_level});
                        }
                        if (detailData.items && detailData.items.length) {
                            this.itemList = detailData.items.map(it => ({
                                item_type: it.item_type,
                                item_code: it.item_code,
                                item_amount: it.item_amount,
                                reimburser_user_id: it.reimburser_user_id,
                                reimburser_name: it.reimburser_name,
                                voucher_images: it.voucher_images || '',
                                selectedReimburser: it.reimburser_user_id ? [{name: it.reimburser_name, value: it.reimburser_user_id}] : [],
                                start_date: it.start_date || '',
                                end_date: it.end_date || '',
                                expense_detail: it.expense_detail || '',
                                is_required_voucher: it.is_required_voucher || 0
                            }));
                        }
                        //处理选中的【售后工单】
                        this.order_id = detailData.order_id || 0;
                        if (detailData.order_id) {
                            this.orderOptions = [{
                                name: detailData.order_number,
                                value: detailData.order_id
                            }];
                        }
                        //加载工单成员列表（与移动端一致，报销人从工单成员中选择）
                        if (detailData.order_id && detailData.reimbursement_type == 1) {
                            this.request({
                                url: '/after/sale/order/detail',
                                data: {id: detailData.order_id},
                                success: ({detailInfo, memberList}) => {
                                    this.memberList = (memberList || []).map(item => ({
                                        name: item.user_realname,
                                        value: item.user_id
                                    }));
									this.outsourceOrder = detailInfo.outsource_recruit_count > 0;
                                }
                            });
                        }
                        //处理选中的【所在公司】
                        if (detailData.company_id) {
                            this.selectedCompany = [{
                                name: detailData.company_name,
                                value: detailData.company_id
                            }];
                        } else {
                            this.selectedCompany = [];
                        }
                        //回填收款账号下拉框
                        if (detailData.payee_name && detailData.payee_card_no) {
                            this.$refs.bankAccountSelect.setValueData([{
                                name: `${detailData.payee_name} | ${detailData.payee_card_no}`,
                                value: detailData.payee_card_no
                            }]);
                            this.$refs.form.set({
                                payee_name: detailData.payee_name,
                                payee_bank_name: detailData.payee_bank_name,
                                payee_card_no: detailData.payee_card_no
                            });
                            this.payeeCardNo = detailData.payee_card_no || '';
                        }
                    }
                });
                this.editState = true;
            } else {
                this.$refs.form.clear();
                this.$refs.form.set({emergency_level: 1});
            }
            this.initExpenseItemCodeDic();
            this.$refs.dialog.open({
                title: this.editState ? (this.order_status == 1 ? '重新发起费用报销' : '编辑费用报销') : '新增费用报销'
            });
        },

        /*******搜索【售后工单】下拉框信息*****************/
        searchAftersaleOrder(keyword, resolve){
            this.request({
                url:'/system/options',
                data: {
                    options_code:'AFTERSALE_ORDER',
                    is_member:1,        //仅查询当前用户参与的工单
                    is_reimbursement:1,  //仅查询当前用户可报销的工单
                    status: [5],
                    keyword:keyword
                },
                success:data => {
                    resolve(data);
                }
            })
        },
        //初始化报销项代码字典，根据报销类型区分，与移动端一致
        initExpenseItemCodeDic(type = [1, 2, 3]) {
            // reimbType == 1 (工单费用报销): kind = 1 (公共费用)  kind = 2 (个人费用)
            // reimbType == 2 (日常费用报销): kind = 3 (日常费用)
            type.forEach(type => {
                this.request({
                    url: '/system/options',
                    data: {
                        options_code: 'DIC_INFO',
                        dic_code: 'COMMONEXPENSE_ITEM',
                        kind: type
                    },
                    success: data => {
						if (!this.outsourceOrder) {
							data = data.filter(item => item.value != 8);
						}
                        this.$set(this.expenseItemCodeDic, type, data);
                    }
                });
            });
        },
        searchUser(keyword, resolve) {
            this.request({
                url: '/system/options',
                data: {options_code: 'SYSUSER', keyword: keyword},
                success: data => resolve(data)
            });
        },
        /*******搜索公司*****************/
        searchCompany(keyword, resolve) {
            this.request({
                url: '/system/options',
                data: {
                    options_code: 'COMPANY',
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            });
        },

        addItem() {
            if (!this.reimbType) {
                this.$message({message: '请先选择报销类型', type: 'warning'});
                return;
            }
            this.itemList.push({
                item_type: this.reimbType == 1 ? 1 : 3,
                item_code: null,
                item_amount: null,
                reimburser_user_id: null,
                reimburser_name: null,
                voucher_images: '',
                voucherFileList: [],
                selectedReimburser: [],
                start_date: '',
                end_date: '',
                expense_detail: '',
                is_required_voucher: 0
            });
        },

        removeItem(index) {
            this.itemList.splice(index, 1);
            this.calcTotal();
        },

        calcTotal() {
            this.$forceUpdate();
        },

        onItemCodeChange(item, selected) {
            // c-select @change 返回选中项对象，需提取 data
            this.$set(item, 'is_required_voucher', selected.data.is_required_voucher);
            // 切换报销项时清空已上传的凭证
            item.voucher_images = '';
            this.$forceUpdate();
        },

        getItemName(code) {
            if (!code) return '未选择';
            const item = this.expenseItemCodeDic.find(it => it.value === code);
            return item ? item.name : '未选择';
        },

        changeDate(item, type) {
            if (item.start_date && item.end_date) {
                if (item.start_date > item.end_date) {
                    this.$message({message: '开始时间需早于结束时间', type: 'warning'});
                    this.$nextTick(() => {
                        item[type] = '';
                    });
                }
            }
        },

        searchBankAccount(keyword, resolve) {
            this.request({
                url: '/sys_user/bank_account/list',
                data: {keyword: (keyword || '').trim()},
                success: data => {
                    resolve((data || []).map(item => ({
                        name: `${item.account_name} | ${item.card_no}`,
                        value: item.card_no,
                        data: item
                    })));
                }
            });
        },

        onReimbTypeChange() {
            // 切换报销类型时清空明细列表，与移动端一致
            this.itemList = [];
            this.memberList = [];
            if (this.reimbType != 1) {
                this.order_id = 0;
                this.orderOptions = [];
            }
        },

        onBankAccountChange(selected) {
            if (!selected) return;
            const item = selected.data;
            if (item) {
                this.payeeCardNo = item.card_no;
                this.$refs.form.set({
                    payee_name: item.account_name,
                    payee_bank_name: item.bank_name,
                    payee_card_no: item.card_no
                });
            }
        },

        manageBankAccount() {
            this.$refs.accountSelector.open();
        },

        onAccountRefresh() {
            // 管理弹框操作后，清空下拉已选项，确保下次打开时重新加载最新数据
            this.payeeCardNo = '';
            this.$refs.bankAccountSelect && this.$refs.bankAccountSelect.setValueData([]);
            this.$refs.form.set({payee_name: '', payee_bank_name: '', payee_card_no: ''});
        },

        /**
         * 提交数据
         * @param status
         */
        submitHandle(status) {
            this.$refs.form.submit({
                url: this.editState ? '/expense/reimbursement/update' : '/expense/reimbursement/add',
                rule: {
                    emergency_level: '请选择紧急程度',
                    reimbursement_type: '请选择报销类型',
                    order_id: [{
                        type: 'empty',
                        message: '请选择关联工单',
                        skip: () => {
                            return this.reimbType != 1;
                        }
                    }],
                    company_id: '请选择所在公司',
                    payee_name: '请选择收款账号',
                    receipts_image_url: [{
                        type: 'empty',
                        message: '请上传服务单据',
                        skip: () => {
                            return this.reimbType != 1;
                        }
                    }],
                    item_list: data => {
                        if (this.itemList.length == 0) {
                            return '请至少添加一条报销明细';
                        }
                        const invalidItem = this.itemList.find(item => {
                            return !item.start_date || !item.end_date || !item.item_amount || (this.reimbType == 1 && !item.reimburser_user_id) || (item.is_required_voucher == 1 && !item.voucher_images) || !item.item_code;
                        });
                        if (invalidItem) {
                            return '请完善报销明细';
                        }
                        // 检查是否存在报销人和报销项相同的明细
                        if (this.reimbType == 1) {
                            const duplicate = this.itemList.find(item => {
                                return this.itemList.find(temp => item !== temp && temp.reimburser_user_id === item.reimburser_user_id && temp.item_code === item.item_code);
                            });
                            if (duplicate) {
                                return '存在报销人和报销项相同的明细';
                            }
                        }
                        return true;
                    }
                },
                dataFormatter: data => {
                    data.id = this.detailData.id || data.id;
                    data.reimbursement_type = this.reimbType;
                    data.receipts_image_url = Array.isArray(data.receipts_image_url) ? data.receipts_image_url.join(',') : (data.receipts_image_url || '');
                    data.report_image_url = Array.isArray(data.report_image_url) ? data.report_image_url.join(',') : (data.report_image_url || '');
                    const items = this.itemList.map(it => {
                        if (!it.item_code || !it.item_amount || it.item_amount <= 0) return null;
                        const reimburser = it.selectedReimburser && it.selectedReimburser[0];
                        return {
                            item_code: it.item_code,
                            item_amount: it.item_amount,
                            reimburser_user_id: this.reimbType == 1 ? it.reimburser_user_id : null,
                            reimburser_name: this.reimbType == 1 ? ((this.memberList.find(m => m.value === it.reimburser_user_id) || {}).name || '') : '',
                            voucher_images: Array.isArray(it.voucher_images) ? it.voucher_images.join(',') : (it.voucher_images || ''),
                            start_date: it.start_date,
                            end_date: it.end_date,
                            expense_detail: it.expense_detail || '',
                            is_required_voucher: it.is_required_voucher || 0
                        };
                    }).filter(it => it !== null);
                    const totalAmount = items.reduce((sum, it) => sum + (parseFloat(it.item_amount) || 0), 0);
                    data.items = items;
                    data.status = status;
                    data.total_amount = totalAmount;
                    return data;
                },
                success: (data, res) => {
                    // 与移动端一致：暂存和提交都走 launch，launch 内部按 state 区分
                    this.$refs.workflowLaunch.launch(res.transaction, () => {
                        this.$refs.dialog.close();
                        this.$message({message: this.editState ? '编辑成功' : '新增成功', type: 'success'});
                        this.$emit('resolve');
                    }, status);
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
.item-card {
    margin-bottom: 12px;
    padding: 12px;
    background: #fafafa;
    border-radius: 4px;
}
</style>
